import { Map, List } from 'immutable'

export default List([
  Map({ label: 'Please select an input format', value: '' }),
  Map({ label: 'Plain text', value: 'plain_text' }),
  Map({ label: 'Basic html', value: 'basic_html' }),
  Map({ label: 'Restricted html', value: 'restricted_html' }),
  Map({ label: 'Full html', value: 'full_html' }),
  Map({ label: 'Markdown', value: 'markdown' }),
])
